function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;


//////////////////
// WEBPACK FOOTER
// /data/public_html/app/themes/aad-matthewalgie/node_modules/@babel/runtime/helpers/iterableToArray.js
// module id = 81
// module chunks = 3